// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AD-0","top":"styles_top__AluzK","left":"styles_left__2Y_jX","description":"styles_description__2gN4R"};